<template>
  <Modal
    :title="title"
    :openModal="display"
    v-on:close-modal="$emit('close-modal')"
  >
    <template v-slot:content>
      <form action="" @submit.prevent="handleClick" id="enableSMSForm"></form>
    </template>
    <template v-slot:footer>
      <Button
        type="submit"
        form="enableSMSForm"
        styling="primary"
        text="Activate"
      ></Button>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../components/Modal/Modal.vue';
import Button from '../../components/Button/Button.vue';

export default {
  name: 'EnableSMSModal',
  emits: ['close-modal'],
  props: ['borrower', 'display'],
  components: {
    Modal,
    Button,
  },
  data() {
    return {
      title: 'Activate SMS Notifications',
    };
  },
  methods: {
    handleClick() {
      this.$confirm({
        message: `Are you sure you want to activate SMS notifications for this borrower?`,
        button: {
          no: 'Cancel',
          yes: 'Yes',
        },
        callback: (confirm) => {
          if (confirm) {
            this.enableSms();
          }
        },
      });
    },
    enableSms() {
      const { ref } = this.borrower;
      this.$store
        .dispatch(`borrowers/enableSms`, {
          ref,
        })
        .then(() => {
          this.$emit('close-modal');
        })
        .catch((err) => {
          this.formErrors = err;
        });
    },
    checkBorrower() {
      if (this.borrower !== null) {
        this.title = `Activate sms notifications for ${this.borrower.name}?`;
      }
    },
  },
  watch: {
    borrower: {
      handler() {
        this.checkBorrower();
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.borrower) this.$emit('close-modal');
    else this.checkBorrower();
  },
};
</script>
